import { combineReducers } from "redux";
import loginState from "./login/reducer";
import homeState from "./home/reducer";
import layoutState from "./layout/reducer";
import configState from "./config/reducer";
import payCitationState from "./pay-citation/reducer";
import profileState from "./profile/reducer";
import citationDetailState from "./citationDetail/reducer";
import driverCitationReducer from "./citation/reducer";
import dashboardState from "./dashboard/reducer";
import registerState from "./register/reducer";
import driverViewOrderReducer from "./vieworder/reducer";
import exitOrderReducer from "./buyPermits/reducer";
import driverPermitListReducer from "./permitList/reducer";
import CitationDetailPDF from "./citationDetailPDF/reducer";
import OrderDetailPDF from "./orderDetailPDF/reducer";
import profileRequired from "./ProfileRequiredField/reducer";
import AddPermitReducerText from "./addPermitText/reducer";
import VehicleRequiredFields from "./vehicleRequiredField/reducer";
import visitorPermitReducer from "./visitorPermit/reducer";
import SystemAlertReducer from "./systemAlert/reducer";
export const createRootReducer = () =>
  combineReducers({
    homeState,
    loginState,
    layoutState,
    configState,
    payCitationState,
    profileState,
    citationDetailState,
    driverCitationReducer,
    dashboardState,
    registerState,
    driverViewOrderReducer,
    exitOrderReducer,
    driverPermitListReducer,
    CitationDetailPDF,
    OrderDetailPDF,
    profileRequired,
    AddPermitReducerText,
    VehicleRequiredFields,
    visitorPermitReducer,
    SystemAlertReducer,
  });
